import React, { Component, useEffect } from 'react';
import '../styles/App.css';
import "aos/dist/aos.css";
import Aos from 'aos';
import img1 from '../assets/g2.png'
import img2 from '../assets/facebook.png'
import img3 from '../assets/yt.png';
import img4 from '../assets/insta.png';
import img5 from '../assets/tiktok.png';
import img6 from '../assets/naver.png';
import img7 from '../assets/twitter.png';
import img8 from '../assets/dicrd.png';
import headset from '../assets/headset.png';
import music from '../assets/music.png';
import star from '../assets/star2.png';

const Stry = () => {
    useEffect(() => {
        Aos.init({ duration: 4000 });
    }, [])
}

class SNS extends Component {

    render() {
        return (

            <div>
                <div class="exMain">
                    <div class="conT" data-aos="zoom-in" data-aos-duration="700">OFFICIAL SNS AD OPERATIONS</div>
                    <p></p>
                    <div class="conT2" data-aos="zoom-in" data-aos-duration="700">The Bunda Music channel operates specialized SNS platforms such as <br /> YouTube, Instagram, Facebook (Meta), TikTok, and Naver.</div>

                    <img className='star' src={star} />

                    <div className='boxMain'>
                        <div className='box2MainExchanges' data-aos="zoom-in" data-aos-duration="700">

                            <div className='community'><img src={img1} /></div>
                            <div className='community'><img src={img2} /></div>
                            <div className='community'><img src={img3} /></div>
                            <div className='community'><img src={img4} /></div>

                        </div>

                        <div className='box2MainExchanges'>
                            <div className='community'><img src={img5} /></div>
                            <div className='community'><img src={img6} /></div>
                            <div className='community'><img src={img7} /></div>
                            <div className='community'><img src={img8} /></div>

                        </div>
                    </div>

                    <div class="conT23">These channels generate advertising and IP revenue, which is used by the company to directly purchase MSC on exchanges. This strategy aims to stabilize prices
                        by minimizing price fluctuations and preventing market manipulation.</div>

                    <div className='phaseSection'>
                        <div className='phaseH'></div>
                        <div className='phaseBox'>
                            <p>Phase 1</p>
                            <div><img src={music} />Activation and optimization of SNS channels (YouTube, TikTok, Instagram).</div>
                        </div>

                        <div className='phaseBox'>
                            <p>Phase 2</p>
                            <div><img src={music} />Securing advertising contracts. Receiving external orders for music and album production.</div>
                        </div>

                        <div className='phaseBox'>
                            <p>Phase 3</p>
                            <div><img src={music} />Expanding into secondary content production by recruiting web variety show producers, web drama directors, writers, and actors.</div>
                            <p></p>
                            <div><img src={music} />Integrating content with platforms such as Spotify, Apple Music, YouTube Music, and iTunes to naturally expose and promote music content.</div>
                        </div>
                    </div>

                </div>

                <img className='headset' src={headset} />

            </div>
        )
    }
}

export default SNS;

